import { Button as BootstrapButton, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { withPopover } from "shared/lib/hocs/withPopover";

function Button({
  isLoading = false,
  children = null,
  popoverRef = (el) => ({}),
  popover = null,
  popoverHandlers = null,
  buttonRef = null,
  ...props
}) {
  const { t } = useTranslation("Shared");
  return (
    <BootstrapButton
      {...props}
      ref={(el) => {
        if (buttonRef) buttonRef(el);
        if (popoverRef) popoverRef(el);
      }}
      className={`d-inline-block ${popoverRef ? "pe-auto" : ""}`}
      {...popoverHandlers}
    >
      {isLoading ? (
        <span style={{ whiteSpace: "nowrap" }}>
          <Spinner
            animation="border"
            variant="light"
            size="sm"
            className="d-inline-block me-2"
          />
          {t("loading")}
        </span>
      ) : (
        children
      )}
    </BootstrapButton>
  );
}

Button.WithPopover = withPopover(Button);
export default Button;
